import React, { useState } from "react";
import WidgetFrame, { WidgetButton } from "./WidgetFrame";
import OptionList from "./OptionList";
import { OTHER_SENTINEL, FORM_ERROR_KEY } from "./kinds";
import { isFilledValue, resolveChoice } from "./useWidgetForm";
import { useWidgetMsg } from "../../../hooks/widget/useWidgetMsg";

/**
 * `question` (spec-widget-mcp 05 Step 4; D-W15): radios for `multiple: false`, checkboxes for `true`;
 * the question is the group's legend (announced once), each option's description its control's
 * accessible description. Other reveals a focused text input and the submitted value is the typed
 * text — the sentinel never leaves this component. Submit waits for a choice (and Other's text).
 * Submits `{ choice }`: the option `value`, or an array of them when `multiple`.
 */
export default function QuestionWidget({ envelope, idPrefix, submitter }) {
	const { msg } = useWidgetMsg();
	const p = envelope.payload || {};
	const multiple = p.multiple === true;
	const [value, setValue] = useState(multiple ? [] : "");
	const [other, setOther] = useState("");
	const otherChosen = multiple ? value.includes(OTHER_SENTINEL) : value === OTHER_SENTINEL;
	const choice = resolveChoice(value, other);
	const ready = isFilledValue(choice) && (!otherChosen || other.trim() !== "");
	const fields = submitter.rejection?.fields || {};
	const error = fields.choice || fields[FORM_ERROR_KEY] || null;

	return (
		<WidgetFrame
			kind="question"
			footer={(
				<WidgetButton
					data-testid="widget-submit"
					onClick={() => submitter.submit({ choice })}
					disabled={!ready || submitter.status === "sending" || !submitter.canSubmit}
				>
					{p.submitLabel || msg("widget.submit", "Send")}
				</WidgetButton>
			)}
		>
			<OptionList
				id={`${idPrefix}-q`}
				legend={p.question}
				subtitle={p.subtitle}
				options={p.options}
				multiple={multiple}
				allowOther={p.allowOther === true}
				value={value}
				other={other}
				onChange={setValue}
				onOtherChange={setOther}
				error={error}
				msg={msg}
			/>
		</WidgetFrame>
	);
}
